
import Config from "../config";
import {EmailTemplateModel,
        EmailTemplateFactory,
        EmailConnectorJSON,
        EmailConnectorModel,
        EmailConnectorFactory,
        EmailRecipientModel,
        EmailMessageModel,
        EmailPreviewJSON,
        EmailPreviewModel,
        EmailPreviewFactory} from '../models/models';

/*
import {formatDate} from "../utils/dateFunctions.js";
import {getIndustryFromVerticalBundle} from "../utils/mapFunctions.js";
*/


export const fetchEmailConnectors = async (authToken: string): Promise<EmailConnectorModel[]> => {

    try {

      //get object information for the selected lookup
      let url = `${Config.getInstance().getCoordinationServiceURL()}/api/email/r/connectors`;
      const headers = new Headers();

      headers.append("Authorization", `Bearer ${authToken}`);
      headers.append("Accept", "application/json");
      headers.append("Content-Type", "application/json");

      const response = await fetch(url, {
        method: "GET",
        headers: headers
      });

      if(!response.ok) {
        const errorData = await response.json();
        if(!errorData.message){
          throw new Error("Unhandled error")
        } else{
          throw new Error(errorData.message);
        }
      }

      const data = await response.json();

      if(!data ||
         !data.email_connectors ||
         !Array.isArray(data.email_connectors)){
          throw new Error("Unhandled error")
      }

      const emailConnectorFactory = new EmailConnectorFactory()
      const connectors = data.email_connectors.map((thisJSON: any) => emailConnectorFactory.fromJSON(thisJSON));

      return connectors

    } catch (error){
      throw new Error(`Error when fetching email connectors: ${(error as Error).message}`)
    }
}


export const fetchEmailTemplate = async (authToken: string, recipient_context: string | null, recordUuid: string): Promise<EmailTemplateModel> => {

    try {

      //get object information for the selected lookup
      let url = `${Config.getInstance().getCoordinationServiceURL()}/api/email/r/template/${recordUuid}`;
      const headers = new Headers();

      headers.append("Authorization", `Bearer ${authToken}`);
      headers.append("Accept", "application/json");
      headers.append("Content-Type", "application/json");

      const body={'recipient_context': recipient_context}

      const response = await fetch(url, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(body)
      });

      if(!response.ok) {
        const errorData = await response.json();
        if(!errorData.message){
          throw new Error("Unhandled error")
        } else{
          throw new Error(errorData.message);
        }
      }

      const data = await response.json();

      if(!data ||
         !data.email_template){
          throw new Error("Unhandled error")
      }


      const emailTemplateFactory = new EmailTemplateFactory()
      const template = emailTemplateFactory.fromJSON(data.email_template);

      return template

    } catch (error){
      throw new Error(`Error when fetching email template: ${(error as Error).message}`)
    }
}

export const fetchEmailPreviews = async (authToken: string, emailMessages: EmailMessageModel[]): Promise<EmailPreviewModel[]> => {
  try {

      let url = `${Config.getInstance().getCoordinationServiceURL()}/api/email/preview/`;
      const headers = new Headers();

      headers.append("Authorization", `Bearer ${authToken}`);
      headers.append("Accept", "application/json");
      headers.append("Content-Type", "application/json");

      const requestBody={email_messages: emailMessages.map((thisMessage: EmailMessageModel) => thisMessage.toJSON())}

      const response = await fetch(url, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(requestBody)
      });


      if(!response.ok) {
        const errorData = await response.json();
        if(!errorData.message){
          throw new Error("Unhandled error");
        } else{
          throw new Error(errorData.message);
        }
      }

      const data = await response.json();

      if(!data ||
         !data.email_previews ||
         !Array.isArray(data.email_previews)){
          throw new Error("Unhandled error");
      }

      const emailPreviewFactory = new EmailPreviewFactory();
      const thisPreviews = data.email_previews.map((thisJSON: EmailPreviewJSON) => emailPreviewFactory.fromJSON(thisJSON));

      return thisPreviews

  } catch (error){
      throw new Error(`Error when fetching previews: ${(error as Error).message}`)
    }

}


export const sendEmailMessages = async (authToken: string, emailMessages: EmailMessageModel[]): Promise<any[]> => {
  try {

      let url = `${Config.getInstance().getCoordinationServiceURL()}/api/email/send/`;
      const headers = new Headers();

      headers.append("Authorization", `Bearer ${authToken}`);
      headers.append("Accept", "application/json");
      headers.append("Content-Type", "application/json");

      const requestBody={email_messages: emailMessages.map((thisMessage: EmailMessageModel) => thisMessage.toJSON())}

      const response = await fetch(url, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(requestBody)
      });


      if(!response.ok) {
        const errorData = await response.json();
        if(!errorData.message){
          throw new Error("Unhandled error");
        } else{
          throw new Error(errorData.message);
        }
      }

      const data = await response.json();


      if(!data ||
         !data.results ||
         !Array.isArray(data.results)){
          throw new Error("Unhandled error");
      }

      const results = data.results.map((thisResult: any) => thisResult.to)
      return results

  } catch (error){
      throw new Error(`Error when sending emails: ${(error as Error).message}`)
    }



}




export const searchRecipients = async (authToken: string, objectApiName: string | null, searchText: string): Promise<EmailRecipientModel[]> => {

    try {

      //get object information for the selected lookup
      let url = `${Config.getInstance().getCoordinationServiceURL()}/api/email/search/?object_api_name=${objectApiName}&search_text=${searchText}`;
      const headers = new Headers();

      headers.append("Authorization", `Bearer ${authToken}`);
      headers.append("Accept", "application/json");
      headers.append("Content-Type", "application/json");

      const response = await fetch(url, {
        method: "GET",
        headers: headers
      });

      if(!response.ok) {
        const errorData = await response.json();
        if(!errorData.message){
          throw new Error("Unhandled error")
        } else{
          throw new Error(errorData.message);
        }
      }
      const data = await response.json();

      if(!data ||
         !data.email_recipients ||
         !Array.isArray(data.email_recipients)){
          throw new Error("Unhandled error");
      }

      const recipients = data.email_recipients.map((thisJSON: any) => new EmailRecipientModel().fromJSON(thisJSON));

      return recipients

    } catch (error){
      throw new Error(`Error when searching for recipients: ${(error as Error).message}`)
    }
}
